
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { ActiveDirectoryConfig } from '../../system/types';

interface AdvancedSettingsProps {
  adConfig: ActiveDirectoryConfig;
  editing: boolean;
}

const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({ adConfig, editing }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Advanced Settings</CardTitle>
        <CardDescription>Configure LDAP filtering and attribute mapping</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="user-filter">User Filter</Label>
            <Input 
              id="user-filter" 
              defaultValue="(&(objectCategory=person)(objectClass=user))" 
              disabled={!editing || adConfig.status !== 'connected'} 
            />
            <p className="text-xs text-muted-foreground">LDAP filter to identify user objects</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="group-filter">Group Filter</Label>
            <Input 
              id="group-filter" 
              defaultValue="(&(objectClass=group))" 
              disabled={!editing || adConfig.status !== 'connected'} 
            />
            <p className="text-xs text-muted-foreground">LDAP filter to identify group objects</p>
          </div>
          
          <div className="pt-4">
            <h4 className="text-sm font-medium mb-2">Attribute Mapping</h4>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="map-username">Username</Label>
                <Input 
                  id="map-username" 
                  defaultValue="sAMAccountName" 
                  disabled={!editing || adConfig.status !== 'connected'} 
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="map-email">Email</Label>
                <Input 
                  id="map-email" 
                  defaultValue="mail" 
                  disabled={!editing || adConfig.status !== 'connected'} 
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="map-firstname">First Name</Label>
                <Input 
                  id="map-firstname" 
                  defaultValue="givenName" 
                  disabled={!editing || adConfig.status !== 'connected'} 
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="map-lastname">Last Name</Label>
                <Input 
                  id="map-lastname" 
                  defaultValue="sn" 
                  disabled={!editing || adConfig.status !== 'connected'} 
                />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdvancedSettings;
